import type { FC } from "react";
import { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import type { CostInvoiceStatus } from "../costApi";
import InvoiceStatusSelect from "./InvoiceStatusSelect";

interface Props {
  readonly open: boolean;
  readonly status: CostInvoiceStatus;
  onCancel: () => void;
  onChange: (status: CostInvoiceStatus) => Promise<void>;
}

const InvoiceStatusDialog: FC<Props> = ({ open, status, onChange, onCancel }) => {
  const [tmpStatus, setTmpStatus] = useState(status);

  useEffect(() => {
    setTmpStatus(status);
  }, [status]);
  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Status faktury</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            marginTop: 1,
          }}
        >
          <InvoiceStatusSelect value={tmpStatus} onChange={setTmpStatus} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" autoFocus onClick={onCancel}>
          Anuluj
        </Button>
        <AsyncLoadingButton onClick={() => onChange(tmpStatus)}>Zmień</AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default InvoiceStatusDialog;
